(() => {
 if (customElements.get('recovered-press-video')) return;
 customElements.define('recovered-press-video', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.video = this.querySelector('video');
   if (!this.video) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
   const toggle = this.querySelector('[data-play]');
   const sound = this.querySelector('[data-sound]');
   const sync = () => {
    if (toggle) { toggle.setAttribute('aria-label',this.video.paused?'Play video':'Pause video'); toggle.querySelector('[data-play-icon]').textContent=this.video.paused?'▶':'Ⅱ'; }
    if (sound) { sound.setAttribute('aria-pressed',String(!this.video.muted)); sound.querySelector('[data-mute-mark]').setAttribute('d',this.video.muted?'m17 9 5 6m0-6-5 6':'M17 8q5 4 0 8'); }
   };
   toggle?.addEventListener('click',()=>this.video.paused?this.play():this.video.pause(),options);
   sound?.addEventListener('click',()=>{this.video.muted=!this.video.muted;sync();},options);
   this.video.addEventListener('play',sync,options);this.video.addEventListener('pause',sync,options);this.video.addEventListener('volumechange',sync,options);
   sync();
   if (reduced) return;
   const threshold = Number(this.dataset.threshold) || .5;
   if (this.dataset.scroll==='true' && 'IntersectionObserver' in window) {
    this.observer=new IntersectionObserver(entries=>{
     entries.forEach(entry=>{
      if(entry.isIntersecting&&entry.intersectionRatio>=threshold){this.video.muted=true;this.play();}
      else if(this.dataset.pauseHidden==='true')this.video.pause();
     });
    },{threshold:[0,threshold]});
    this.observer.observe(this.video);
   } else if(this.dataset.scroll!=='true'&&this.dataset.immediate==='true'){this.video.muted=true;this.play();}
  }
  play(){const promise=this.video.play();if(promise?.catch)promise.catch(()=>{this.video.controls=true;});}
  disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.abort=null;this.video?.pause();}
 });
})();
